import { Helmet } from "react-helmet-async";
import envConstants from "../Constants";
const ShippingOption = () => {
    const canonicalUrl = 'https://autopartstation.com.au/shipping-policy';
    const schemaMarkup = {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Shipping Options - Auto Part Station",
        "url": "https://autopartstation.com.au/shipping-option",
        "mainEntity": {
            "@type": "Organization",
            "name": "Auto Part Station Pty Ltd",
            "url": "https://autopartstation.com.au",
            "logo": "https://autopartstation.com.au/auto-part.png"
        }
    };
    return (
        <div className="container my-4">
            <Helmet>
                <title>Fast & Reliable Auto Parts Shipping Now | Auto Part Station</title>
                <meta name="description" content="Explore shipping options at Auto Part Station. Fast and reliable delivery to get your auto parts quickly!" />
                <meta name="author" content={envConstants.STORE_META_AUTHOR ? envConstants.STORE_META_AUTHOR : 'Auto Part Station Store'} />
                <meta name="keywords" content="Auto Part Station shipping option, shipping option Auto Part Station" />
                <link rel="canonical" href={canonicalUrl} />
                <script type="application/ld+json">
                    {JSON.stringify(schemaMarkup)}
                </script>
            </Helmet>
            <h2>Shipping Policy</h2>
            <p>At <strong>Auto Part Station</strong>, we are committed to providing fast, reliable, and secure delivery service for your order across Australia. Here’s a detailed overview of our shipping process:</p>
            <h5>Order Processing and Delivery Schedule:</h5>
            <p>Once you place an order on our website, our team begins processing it right away. To help you plan your purchase, please refer to the following schedule:</p>
            <ul>
                <li><strong>Order Cutoff Time:</strong> 6:00 PM (AEST)</li>
                <li><strong>Order Handling Time:</strong> 0–1 business days (Monday – Sunday)</li>
                <li><strong>Delivery Time:</strong> 5–8 business days (Monday – Sunday)</li>
            </ul>
            <h5>Shipping Coverage:</h5>
            <p>We currently ship only within Australia. Unfortunately, we do not offer international shipping at this time.</p>
            <h5>Shipping Charges:</h5>
            <ul>
                <li><strong>Free Shipping</strong> on all orders <strong>above A$100</strong></li>
                <li>A flat <strong>A$15 shipping fee</strong> applies to orders <strong>below A$100</strong></li>
            </ul>
            <h5>Shipping Partners:</h5>
            <p>To ensure safe and timely delivery, we work with a network of <strong>reliable courier partners</strong>, including <strong>Australia Post, Aramex, CouriersPlease</strong>, and others, depending on your location and order size.</p>
            <h5>Order Confirmation:</h5>
            <p>After placing your order, you will receive a confirmation email with your order number and details. Once shipped, a second email will include your tracking number and a tracking link. We'll also notify you upon successful delivery.</p>
            <h5>Lost or Missing Packages:</h5>
            <p>If your package is marked as delivered but you haven’t received it, please:</p>
            <ul>
                <li>Confirm that your shipping address is correct</li>
                <li>Check around your property and with neighbors.</li>
                <li>Contact the courier using your tracking number.</li>
            </ul>
            <p>If the courier confirms the package is lost, contact us immediately with your order number. We’ll arrange a replacement or refund based on your preference.</p>
            <h5>Contact Us:</h5>
            <p>If you need assistance or have any questions, reach out to our friendly support team:</p>
            <p>
               <span><strong>Email:</strong> <a href="mailto:sales@autopartstation.com.au" className="text-decoration-none text-dark">sales@autopartstation.com.au</a></span>
               <br />
               <span><strong>Phone:</strong> <a href="tel:+61490533318" className="text-decoration-none text-dark">+61 490 533 318</a></span>
               <br />
               <span><strong>Operating Hours:</strong> Monday – Sunday | 8:00 AM – 6:00 PM AEST</span>
            </p>
        </div>
    )
}

export default ShippingOption;